<div class="notification-center">
  <!-- Header -->
  <div class="notification-header">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="mb-0">
        <i class="bi bi-bell-fill me-2"></i>
        {{ 'Notifications.Title' | translate }}
        <span *ngIf="unreadCount > 0" class="badge badge-soft-danger ms-2">{{ unreadCount }}</span>
      </h5>
      <div class="d-flex gap-2">
        <button
          class="btn btn-action-outline btn-sm"
          (click)="onRefresh()"
          [disabled]="loading"
          [attr.title]="'Notifications.Refresh' | translate"
        >
          <i class="bi bi-arrow-clockwise"></i>
          <span class="visually-hidden">{{ 'Notifications.Refresh' | translate }}</span>
        </button>
        <button
          class="btn btn-action-outline btn-sm"
          (click)="onTogglePreferences()"
          [attr.title]="'Notifications.Preferences' | translate"
        >
          <i class="bi bi-gear"></i>
          <span class="visually-hidden">{{ 'Notifications.Preferences' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Preferences Panel -->
  <div *ngIf="showPreferences" class="preferences-panel card mb-3">
    <div class="card-header">
      <h6 class="mb-0">{{ 'Notifications.PreferencesTitle' | translate }}</h6>
    </div>
    <div class="card-body">

      <!-- Global defaults -->
      <h6 class="text-muted mb-2">
        <i class="bi bi-sliders me-1"></i>
        {{ 'Notifications.GlobalDefaults' | translate }}
      </h6>
      <p class="text-muted small mb-3">{{ 'Notifications.GlobalDefaultsDescription' | translate }}</p>
      <div class="form-check form-switch mb-2">
        <input
          class="form-check-input"
          type="checkbox"
          id="inAppEnabled"
          [(ngModel)]="preferences.InAppEnabled"
        />
        <label class="form-check-label" for="inAppEnabled">
          <i class="bi bi-app-indicator me-2"></i>
          {{ 'Notifications.InAppNotifications' | translate }}
        </label>
      </div>
      <div class="form-check form-switch mb-2">
        <input
          class="form-check-input"
          type="checkbox"
          id="emailEnabled"
          [(ngModel)]="preferences.EmailEnabled"
        />
        <label class="form-check-label" for="emailEnabled">
          <i class="bi bi-envelope me-2"></i>
          {{ 'Notifications.EmailNotifications' | translate }}
        </label>
      </div>
      <div class="form-check form-switch mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          id="smsEnabled"
          [(ngModel)]="preferences.SMSEnabled"
        />
        <label class="form-check-label" for="smsEnabled">
          <i class="bi bi-phone me-2"></i>
          {{ 'Notifications.SMSNotifications' | translate }}
        </label>
      </div>
      <div *ngIf="!atLeastOneGlobalEnabled" class="alert alert-warning py-2 px-3 mb-3 small">
        <i class="bi bi-exclamation-triangle me-1"></i>
        {{ 'Notifications.AtLeastOneChannelRequired' | translate }}
      </div>

      <div class="d-flex gap-2 mb-4">
        <button
          class="btn btn-action-dark btn-sm"
          (click)="onSavePreferences()"
          [disabled]="savingPreferences || !atLeastOneGlobalEnabled"
          [title]="!atLeastOneGlobalEnabled ? ('Notifications.AtLeastOneChannelRequired' | translate) : ''"
        >
          <span *ngIf="savingPreferences" class="spinner-border spinner-border-sm me-1"></span>
          <i *ngIf="!savingPreferences" class="bi bi-check-circle me-1"></i>
          {{ 'Notifications.Save' | translate }}
        </button>
        <button
          class="btn btn-action-outline btn-sm"
          (click)="onTogglePreferences()"
          [disabled]="savingPreferences"
        >
          <i class="bi bi-x-circle me-1"></i>
          {{ 'Notifications.Cancel' | translate }}
        </button>
      </div>

      <!-- Per-category preferences -->
      <ng-container *ngIf="categoryPreferences.length > 0">
        <hr class="my-3">
        <h6 class="text-muted mb-2">
          <i class="bi bi-tags me-1"></i>
          {{ 'Notifications.NotificationCategories' | translate }}
        </h6>
        <p class="text-muted small mb-3">
          {{ 'Notifications.CategoriesDescription' | translate }}
        </p>

        <div class="table-responsive">
          <table class="table table-sm table-hover align-middle category-pref-table mb-3">
            <thead>
              <tr>
                <th>{{ 'Notifications.CategoryHeader' | translate }}</th>
                <th class="text-center" style="width:60px" [attr.title]="'In-App'">
                  <i class="bi bi-app-indicator"></i>
                </th>
                <th class="text-center" style="width:60px" [attr.title]="'E-post'">
                  <i class="bi bi-envelope"></i>
                </th>
                <th class="text-center" style="width:60px" [attr.title]="'SMS'">
                  <i class="bi bi-phone"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- CRM group -->
              <ng-container *ngIf="crmCategories.length > 0">
                <tr class="table-light">
                  <td colspan="4" class="fw-semibold">
                    <i class="bi bi-people me-1"></i>{{ 'Notifications.GroupCRM' | translate }}
                  </td>
                </tr>
                <tr *ngFor="let cat of crmCategories">
                  <td>
                    <div class="fw-semibold small">{{ cat.label }}</div>
                    <div class="text-muted" style="font-size:0.75rem">{{ cat.description }}</div>
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowInApp">
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowEmail">
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowSMS">
                  </td>
                </tr>
              </ng-container>

              <!-- Prosjekt group -->
              <ng-container *ngIf="projectCategories.length > 0">
                <tr class="table-light">
                  <td colspan="4" class="fw-semibold">
                    <i class="bi bi-kanban me-1"></i>{{ 'Notifications.GroupProject' | translate }}
                  </td>
                </tr>
                <tr *ngFor="let cat of projectCategories">
                  <td>
                    <div class="fw-semibold small">{{ cat.label }}</div>
                    <div class="text-muted" style="font-size:0.75rem">{{ cat.description }}</div>
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowInApp">
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowEmail">
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowSMS">
                  </td>
                </tr>
              </ng-container>

              <!-- HMS group -->
              <ng-container *ngIf="hmsCategories.length > 0">
                <tr class="table-light">
                  <td colspan="4" class="fw-semibold">
                    <i class="bi bi-shield-check me-1"></i>{{ 'Notifications.GroupHMS' | translate }}
                  </td>
                </tr>
                <tr *ngFor="let cat of hmsCategories">
                  <td>
                    <div class="fw-semibold small">{{ cat.label }}</div>
                    <div class="text-muted" style="font-size:0.75rem">{{ cat.description }}</div>
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowInApp">
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowEmail">
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowSMS">
                  </td>
                </tr>
              </ng-container>

              <!-- Håndbok group -->
              <ng-container *ngIf="handbookCategories.length > 0">
                <tr class="table-light">
                  <td colspan="4" class="fw-semibold">
                    <i class="bi bi-book me-1"></i>{{ 'Notifications.GroupHandbook' | translate }}
                  </td>
                </tr>
                <tr *ngFor="let cat of handbookCategories">
                  <td>
                    <div class="fw-semibold small">{{ cat.label }}</div>
                    <div class="text-muted" style="font-size:0.75rem">{{ cat.description }}</div>
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowInApp">
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowEmail">
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowSMS">
                  </td>
                </tr>
              </ng-container>

              <!-- Nyheter group -->
              <ng-container *ngIf="newsCategories.length > 0">
                <tr class="table-light">
                  <td colspan="4" class="fw-semibold">
                    <i class="bi bi-newspaper me-1"></i>{{ 'Notifications.GroupNews' | translate }}
                  </td>
                </tr>
                <tr *ngFor="let cat of newsCategories">
                  <td>
                    <div class="fw-semibold small">{{ cat.label }}</div>
                    <div class="text-muted" style="font-size:0.75rem">{{ cat.description }}</div>
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowInApp">
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowEmail">
                  </td>
                  <td class="text-center">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="cat.allowSMS">
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

        <button
          class="btn btn-action-dark btn-sm"
          (click)="onSaveCategoryPreferences()"
          [disabled]="savingCategoryPreferences"
        >
          <span *ngIf="savingCategoryPreferences" class="spinner-border spinner-border-sm me-1"></span>
          <i *ngIf="!savingCategoryPreferences" class="bi bi-check-circle me-1"></i>
          {{ 'Notifications.SaveCategories' | translate }}
        </button>
      </ng-container>

    </div>
  </div>

  <!-- Toolbar -->
  <div class="toolbar d-flex justify-content-between align-items-center mb-3">
    <div class="btn-group btn-group-sm" role="group">
      <button
        type="button"
        class="btn"
        [class.btn-action-info]="showOnlyUnread"
        [class.btn-action-outline]="!showOnlyUnread"
        (click)="onToggleFilter()"
      >
        <i class="bi bi-circle-fill me-1" *ngIf="showOnlyUnread"></i>
        {{ 'Notifications.UnreadFilter' | translate }}
      </button>
      <button
        type="button"
        class="btn"
        [class.btn-action-info]="!showOnlyUnread"
        [class.btn-action-outline]="showOnlyUnread"
        (click)="onToggleFilter()"
      >
        <i class="bi bi-list-ul me-1" *ngIf="!showOnlyUnread"></i>
        {{ 'Notifications.AllFilter' | translate }}
      </button>
    </div>

    <button
      *ngIf="unreadCount > 0"
      class="btn btn-action-outline btn-sm"
      (click)="onMarkAllAsRead()"
      [attr.title]="'Notifications.MarkAllAsRead' | translate"
    >
      <i class="bi bi-check-all"></i>
      {{ 'Notifications.MarkAllAsRead' | translate }}
    </button>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="loading && notifications.length === 0" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'Notifications.Loading' | translate }}</span>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && notifications.length === 0" class="empty-state text-center py-5">
    <i class="bi bi-bell-slash display-1 text-muted mb-3"></i>
    <h5 class="text-muted">{{ 'Notifications.NoNotifications' | translate }}</h5>
    <p class="text-muted">{{ 'Notifications.NoNotificationsMessage' | translate:{ type: showOnlyUnread ? ('Notifications.Unread' | translate) : '' } }}</p>
  </div>

  <!-- Notifications List -->
  <div class="notifications-list">
    <div
      *ngFor="let notification of notifications"
      class="notification-item"
      [class.unread]="!notification.IsRead"
      [class]="getPriorityClass(notification.Priority)"
    >
      <div class="notification-content"
        [class.clickable]="!!notification.NavigationUrl"
        (click)="notification.NavigationUrl ? onNavigate(notification) : (!notification.IsRead && onMarkAsRead(notification))">
        <div class="d-flex justify-content-between align-items-start">
          <div class="flex-grow-1">
            <!-- Priority Icon -->
            <i
              [class]="'bi ' + getPriorityIcon(notification.Priority) + ' me-2'"
              *ngIf="notification.Priority && notification.Priority !== 'Normal'"
            ></i>
            
            <!-- Subject -->
            <strong [class.text-primary]="!notification.IsRead">
              {{ notification.Subject }}
            </strong>
            
            <!-- Unread indicator -->
            <span *ngIf="!notification.IsRead" class="badge badge-soft-primary ms-2">{{ 'Notifications.NewBadge' | translate }}</span>
            
            <!-- Deep-link indicator -->
            <i *ngIf="notification.NavigationUrl" class="bi bi-box-arrow-up-right ms-1 text-muted" style="font-size: 0.75rem;"></i>
          </div>

          <!-- Actions -->
          <div class="notification-actions">
            <button
              *ngIf="!notification.IsRead"
              class="btn btn-sm btn-action-outline"
              (click)="onMarkAsRead(notification); $event.stopPropagation()"
              [attr.title]="'Notifications.MarkAsRead' | translate"
            >
              <i class="bi bi-check"></i>
              <span class="visually-hidden">{{ 'Notifications.MarkAsRead' | translate }}</span>
            </button>
            <button
              class="btn btn-sm btn-action-danger-outline"
              (click)="onDelete(notification); $event.stopPropagation()"
              [attr.title]="'Notifications.Delete' | translate"
            >
              <i class="bi bi-trash3"></i>
              <span class="visually-hidden">{{ 'Notifications.Delete' | translate }}</span>
            </button>
          </div>
        </div>

        <!-- Message Body -->
        <div class="notification-body mt-2" [innerHTML]="notification.MessageBody"></div>

        <!-- Footer -->
        <div class="notification-footer mt-2">
          <small class="text-muted">
            <i class="bi bi-clock me-1"></i>
            {{ formatDateTime(notification.CreatedDate) }}
          </small>
          <small *ngIf="notification.IsRead && notification.ReadDate" class="text-muted ms-3">
            <i class="bi bi-check-circle me-1"></i>
            {{ 'Notifications.ReadAt' | translate }} {{ formatDateTime(notification.ReadDate) }}
          </small>
          <a *ngIf="notification.NavigationUrl"
             class="ms-3 small text-decoration-none"
             href="javascript:void(0)"
             (click)="onNavigate(notification); $event.stopPropagation()">
            <i class="bi bi-box-arrow-up-right me-1"></i>{{ 'Notifications.OpenObject' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Load More -->
  <div *ngIf="hasMore && !loading" class="text-center mt-3">
    <button class="btn btn-action-outline" (click)="onLoadMore()">
      <i class="bi bi-arrow-down-circle me-2"></i>
      {{ 'Notifications.LoadMore' | translate }}
    </button>
  </div>

  <!-- Loading More Spinner -->
  <div *ngIf="loading && notifications.length > 0" class="text-center py-3">
    <div class="spinner-border spinner-border-sm text-primary" role="status">
      <span class="visually-hidden">{{ 'Notifications.Loading' | translate }}</span>
    </div>
  </div>
</div>
